'use strict';
module.exports = require('./Api.js');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/api/index.js
// module id = 770
// module chunks = 7